"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _booking = require("../../lib/booking");
var _bookingButton = _interopRequireDefault(require("../BookingButton/booking-button"));
var _bookingInfo = _interopRequireDefault(require("../BookingInfo/booking-info"));
const ProviderBooking = _ref => {
  let {
    provider,
    modalDisplay,
    bookingCallback,
    shouldDisplayAvailability,
    slotsStatus,
    track
  } = _ref;
  if ((0, _booking.shouldShowBooking)(provider, modalDisplay)) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_bookingButton.default, {
      provider: provider,
      modalDisplay: modalDisplay,
      bookingCallback: bookingCallback,
      track: track
    }), /*#__PURE__*/_react.default.createElement(_bookingInfo.default, {
      provider: provider,
      shouldDisplayAvailability: shouldDisplayAvailability,
      slotsStatus: slotsStatus
    }));
  } else {
    return null;
  }
};
var _default = exports.default = ProviderBooking;
ProviderBooking.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ProviderBooking"
};